module.exports = function anonymous(locals, escape, include, rethrow) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"ofs-infowindow-arrow\"><span></span></div>\n<div class=\"ofs-infowindow-content\">\n  <div class=\"close\">&times;</div>\n  <div class=\"unit-detail-header\">\n    <a href=\"")
    ; __append(escape(model.get('site_url')))
    ; __append("\"><img src=\"")
    ; __append(escape(model.get('image_url')))
    ; __append("\" style=\"max-width: 100%;\" /></a>\n    <h2><a href=\"")
    ; __append(escape(model.get('site_url')))
    ; __append("\">")
    ; __append(escape(model.get('name')))
    ; __append("</a></h2>\n    ")
    ;  if (model.get('location')) { 
    ; __append("\n    <p class=\"location quiet\">")
    ; __append(escape(model.get('location')))
    ; __append("</p>\n    ")
    ;  } 
    ; __append("\n    <p><a href=\"")
    ; __append(escape(model.get('site_url')))
    ; __append("\">More details</a></p>\n  </div>\n</div>\n<div class=\"ofs-infowindow-footer\">\n  ")
    ;  if (model.get('price')) { 
    ; __append("<div class=\"price\">from <strong>")
    ; __append(model.get('price'))
    ; __append("</strong>/night</div>\n  ")
    ;  } else if (model.get('currency_code') && model.get('marketing_price')) { 
    ; __append("<div class=\"price\">from <strong>")
    ; __append(escape(model.get('currency_code')))
    ; __append(escape(model.get('marketing_price')))
    ; __append("</strong>/night</div>\n  ")
    ;  } 
    ; __append("\n  <div class=\"footerbits\">\n    <span class=\"icon-sleeps-nocircle\"></span>")
    ; __append(escape(model.get('sleeps')))
    ;  if (model.get('sleeps_max') > model.get('sleeps')) { 
    ; __append(" &ndash; ")
    ; __append(escape(model.get('sleeps_max')))
    ;  } 
    ; __append("\n    <span class=\"icon-bedrooms-nocircle\"></span>")
    ; __append(escape(model.get('bedrooms')))
    ; __append("\n  </div>\n</div>\n")
  }
  return __output.join("");

}


/*****************
 ** WEBPACK FOOTER
 ** ./static/js/onefinestay/templates/unit-detail.ejs
 ** module id = 630
 ** module chunks = 46
 **/